import axios from "axios";
import { notificationservice } from "../../config";

const base_url = notificationservice.uri;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;
  return {
    Authorization: formattedToken,
    "Content-Type": "application/json",
  };
};

const DASHBOARD_MESSAGE_FIELDS = `
  id
  title
  body
  category
  displayType
  priority
  targetRoleGroup
  isDismissible
  startsAt
  expiresAt
  ctaLabel
  ctaUrl
  createdBy
  createdAt
  updatedAt
`;

// The dashboard_messages resolvers return the typed object/list directly —
// unlike most of this app's GraphQL surface, there is no { results, error }
// JSON-string envelope here — so this entity is served by plain GraphQL
// requests rather than the generic jsondynamicservice helpers.
//
// The backend also emits a spurious per-field "Forbidden" error on every
// dashboard_messages request while still returning the full, correct data
// alongside it (a field-authorization directive that logs but doesn't
// actually block). Treat presence of `data` as success and only throw when
// there's no usable data to fall back on.
const postGraphQL = async (query) => {
  const response = await axios.post(
    base_url,
    { query },
    { headers: getAuthHeaders() }
  );
  const { data, errors } = response.data || {};
  if (!data) {
    throw new Error(errors?.[0]?.message || "Request failed");
  }
  if (errors?.length) {
    console.warn("dashboardMessages: GraphQL returned errors alongside data", errors);
  }
  return data;
};

const formatGraphQLValue = (value) => {
  if (typeof value === "string") return JSON.stringify(value);
  if (Array.isArray(value)) {
    return `[${value.map(formatGraphQLValue).join(", ")}]`;
  }
  if (value === null || value === undefined) return "null";
  return value;
};

const buildInputArgs = (fields) =>
  Object.entries(fields)
    .map(([key, value]) => `${key}: ${formatGraphQLValue(value)}`)
    .join(", ");

export const fetchActiveDashboardMessages = async () => {
  const data = await postGraphQL(
    `{ activeDashboardMessages { ${DASHBOARD_MESSAGE_FIELDS} } }`
  );
  return data.activeDashboardMessages || [];
};

export const fetchAllDashboardMessages = async () => {
  const data = await postGraphQL(
    `{ allDashboardMessages { ${DASHBOARD_MESSAGE_FIELDS} } }`
  );
  return data.allDashboardMessages || [];
};

export const createDashboardMessage = async (input) => {
  const data = await postGraphQL(
    `mutation { createDashboardMessage(message: { ${buildInputArgs(
      input
    )} }) { ${DASHBOARD_MESSAGE_FIELDS} } }`
  );
  return data.createDashboardMessage;
};

export const updateDashboardMessage = async (input) => {
  const data = await postGraphQL(
    `mutation { updateDashboardMessage(message: { ${buildInputArgs(
      input
    )} }) { ${DASHBOARD_MESSAGE_FIELDS} } }`
  );
  return data.updateDashboardMessage;
};
